import React from "react";
import "./css/WhatsAppButton.css";

function WhatsAppButton() {
  const phone = "";
  const msg = encodeURIComponent("Hola! Quiero consultar por disponibilidad.");
  const href = phone
    ? `https://wa.me/${phone}?text=${msg}`
    : `https://wa.me/?text=${msg}`;
  return (
    <a
      className="whatsapp-fab"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
    >
      {/* Simple SVG icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path d="M13.601 2.326A7.854 7.854 0 0 0 8.024.001C3.709 0 .205 3.503.204 7.817c0 1.377.356 2.72 1.03 3.912L0 16l4.37-1.208a7.78 7.78 0 0 0 3.653.93h.003c4.315 0 7.818-3.503 7.819-7.817a7.78 7.78 0 0 0-2.244-5.579ZM8.026 14.51h-.003a6.54 6.54 0 0 1-3.333-.914l-.24-.143-2.59.716.693-2.524-.156-.259A6.54 6.54 0 0 1 1.34 7.82c0-3.614 2.943-6.557 6.584-6.557a6.54 6.54 0 0 1 4.655 1.928 6.54 6.54 0 0 1 1.928 4.63c-.001 3.614-2.944 6.557-6.58 6.557Zm3.69-4.934c-.2-.1-1.18-.58-1.36-.646-.18-.067-.31-.1-.44.1-.13.2-.5.647-.61.78-.11.133-.22.15-.42.05-.2-.1-.85-.31-1.62-.99-.6-.534-1.006-1.2-1.12-1.4-.12-.2-.01-.3.09-.4.09-.09.2-.233.3-.35.1-.12.13-.2.2-.33.07-.13.04-.25-.02-.35-.06-.1-.44-1.06-.6-1.45-.16-.39-.33-.34-.45-.35-.12-.01-.25-.01-.38-.01a.73.73 0 0 0-.53.25c-.18.2-.69.67-.69 1.64 0 .97.71 1.9.81 2.03.1.13 1.39 2.12 3.37 2.97.47.2.84.32 1.13.41.47.15.9.13 1.24.08.38-.06 1.18-.48 1.35-.94.17-.46.17-.86.12-.95-.05-.09-.18-.14-.38-.24Z" />
      </svg>
    </a>
  );
}

export default WhatsAppButton;
